var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedDataReportsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.99992H5.33333V5.99992H16V9.99992ZM5.33333 4.66659H16C16 2.82859 14.5047 1.33325 12.6667 1.33325H5.33333V4.66659ZM4 5.99992H0V9.99992H4V5.99992ZM5.33333 14.6666H12.6667C14.5047 14.6666 16 13.1713 16 11.3333H5.33333V14.6666ZM4 1.33325H3.33333C1.49533 1.33325 0 2.82859 0 4.66659H4V1.33325ZM4 11.3333H0C0 13.1713 1.49533 14.6666 3.33333 14.6666H4V11.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedDataReportsIcon);
export default __webpack_public_path__ + "static/media/SelectedDataReportsIcon.9522b7147b18c3ce82a7b616de287ed0.svg";
export { ForwardRef as ReactComponent };